import { useQuery } from "@tanstack/react-query";
import { BaseModal, ModalCloseCross, type BaseModalProps } from "@/components/modals/BaseModal";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { useState } from "react";
import type { DBPrioritaria } from "../SincroAlmacen";
import { TablaLogSincro } from "./TablaLogSincro";
import { Loading, QueryError } from "@/components/Loading/Loading";


interface ModalLogSincroProps extends BaseModalProps { }
export function ModalLogsSincro(props: ModalLogSincroProps) {
	// $("#comboLogSincro").on("change", function (this: HTMLElement) {
	// 	const logcab_id = $(this).val() as string;
	// 	void getLineasSincronizacion(logcab_id);
	// });
	const [logCabID, setLogCabID] = useState<number | null>(null);


	return (
		<BaseModal show={props.show} close={props.close} minWidth="60%">
			<div className="modal-header">
				<h4 className="modal-title">Historial de sincronizaciones</h4>
				<ModalCloseCross onClick={props.close} />
			</div>
			<div className="modal-body">
				<FiltroCabecera idLogCabSincro={logCabID} setLogCabID={setLogCabID} />
				<TablaLogSincro idLogCabSincro={logCabID} />
			</div>
			<div className="modal-footer">
				<button type="button" className="btnSecondary" onClick={props.close}>
					Cerrar
				</button>
			</div>
		</BaseModal>
	);
}

function FiltroCabecera(props: { readonly idLogCabSincro: number | null; readonly setLogCabID: (id: number | null) => void; }) {
	const { data, error, isPending } = useLogsCabecera();

	if (error) return <QueryError error={error} fallback="Error al cargar los datos" />;
	if (isPending) return <Loading />;

	return (
		<div style={{ padding: "0 30px 15px 30px", display: "flex" }}>
			<label style={{ fontSize: 17, marginTop: 6, marginRight: 5, width: "45%" }}>Selecciona un registro: </label>
			<select className="form-control" value={props.idLogCabSincro ?? ""} onChange={event => { props.setLogCabID(Number(event.target.value) || null); }}>
				<option value=''>Seleccion una opción</option>
				{data.data.map((linea) => (
					<option key={linea.id} value={linea.id}> {linea.id} - {linea.xfecha}</option>
				))}
			</select>
		</div>
	);
}

export function useLogsCabecera() {
	return useQuery({
		queryKey: ["getLogsCab"],
		queryFn: () => {
			return sendAjaxRequest<RespuestaLogsCab>("GET", "/api/v1/getLogsCab");
		},
	});
}
export function useLogsLinea(logcab_id: number | null) {
	return useQuery<LogSincro[] | null>({
		queryKey: ["getLogsSincro", logcab_id],
		queryFn: () => {
			const url = "/api/v1/getLogsSincro";
			if (logcab_id === null) return Promise.resolve(null);
			return sendAjaxRequest<LogSincro[]>("GET", url, { "idLogCabSincro": logcab_id });
		},
	});
}
export interface RespuestaLogsCab {
	data: Array<{ id: number; xfecha: string; }>;
}
export interface LogSincro {
	id: number;
	logcabsincro_id: number;
	articulo_id: string;
	almacen_id: string;
	prioritaria: DBPrioritaria;
	cantidad_sumar: number;
}
